import { boolean, defineAction, number, object, string } from '~/prix'
import actionDefinition from './geoMunicipalityImportUrbanArea.action.json' with { type: 'json' }

const geoMunicipalityImportUrbanAreaDefinition = defineAction({
  ...actionDefinition,
  input: object({
    municipalityId: number(),
    geojson: object<any>({}),
  }),
  output: object({
    municipalityId: number(),
    municipalityName: string(),
    result: boolean(),
  }),
})

export default geoMunicipalityImportUrbanAreaDefinition
